import { useRoutes } from 'react-router-dom';
import router from 'src/router';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
//import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { LocalizationProvider } from '@mui/x-date-pickers';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { UserProvider } from './store/user-info-context';
import './App.css';

function App() {
  const content = useRoutes(router);

  return (
    <UserProvider>
    <ThemeProvider>
      {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
        <CssBaseline />
        {content}
      {/* </LocalizationProvider> */}
    </ThemeProvider>
    </UserProvider>
  );
}
export default App;
